// removed by extract-text-webpack-plugin
module.exports = {"option-wrapper":"option__option-wrapper__1PtZd","option-header":"option__option-header__1jtLh","title":"option__title__2b9Md","common-wrapper":"option__common-wrapper__dUMhZ","option-voted":"option__option-voted__ftJ3q","option-notes":"option__option-notes__2xnAG","option-label":"option__option-label__T9zve","option-ul":"option__option-ul__2uv-W","option-li":"option__option-li__2pJF8","line":"option__line__1MTyL","button":"option__button__8JfDU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/SignUpListContainer/Option/option.scss
// module id = 1390
// module chunks = 1